import { GenealogyService,TreeViewService,SponserTreeService,DownlineMembersService,ReferralMembersService } from "../../services/tree/network";
export const GenealogyActions = {
  getTreelist: async (plan,userId, userName) => {
    try{
      const response = await GenealogyService.getTreelist(plan,userId, userName)
      return response
    } catch (error) {
      return error.message
    }
  },
  getUnilevelMore: async (fatherId, position) => {
    try {
      const response = await GenealogyService.getUnilevelMore(fatherId, position)
      return response
    } catch (error) {
      return error.message
    }
  }
};

export const TreeViewActions = {
  getTreelist: async (treePlan,userId) => {
    try {
      const response = await TreeViewService.getTreelist(treePlan,userId)
      return response
    } catch (error) {
      return error.message
    }
  }
};

export const SponserTreeActions = {
  getTreelist: async (treePlan,userId, userName) => {
    try {
      const response = await SponserTreeService.getTreelist(treePlan,userId, userName)
      return response
    } catch (error) {
      return error.message
    }
  }
};
export const downlineMembersActions={
  getDownlineMembers:async(plan,level,page,itemsPerPage)=>{
    try {
      const response=await DownlineMembersService.callDownline(plan,level,page,itemsPerPage)
      return response
    } catch (error) {
      return error.message
    }
  },
  getDownlineheaders:async(plan)=>{
    try {
      const response=await DownlineMembersService.callHeader(plan)
      return response
    } catch (error) {
      return error.message
    }
  }

}

export const ReferralMembersActions={
  getReferralmembers:async(treePlan,level,page,itemsPerPage)=>{
    try {
      const response=await ReferralMembersService.callReferral(treePlan,level,page,itemsPerPage)
      return response
    } catch (error) {
      return error.message
    }
  },
  getRferralHeader:async(treePlan)=>{
    try {
      const response=await ReferralMembersService.callHeader(treePlan)
      return response
    } catch (error) {
      return error.message
    }
  }
}